<template>
  <div class="page">
    <Menu />
    <section class="cContent">
      <div class="list">
        <CourseList :list="searchObj.data" :keyStr="'searchCourseList'" />
      </div>
      <pager
        :total-page="Math.ceil(searchObj.total / pageSize)"
        :init-page="searchObj.current_page"
        @go-page="goPage"
      ></pager>
    </section>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import pager from "@/components/pager.vue";
import CourseList from "@/components/CourseList.vue";
import Footer from "@/components/Footer.vue";
import {search} from "@/api/course.js";

export default {
  data() {
    return { 
      page: 1,
      pageSize: 10, 
      searchObj: {}, 
      searchKey:'',
    };
  },
  mounted() {
    //是否有从其他页面传递分类id
    if (this.$route.params.q) {
       this.searchKey = this.$route.params.q;
       this.loadData();
    }
  },
  methods: { 
    loadData:function(){
		search(this.page,this.pageSize,this.searchKey).then(resp=>{
           if(resp != -1){
               this.searchObj = resp;
           }
       })
    },
    goPage: function(e) {
      this.page = e.page;
      this.loadData();
    }
  },
  components: {
    Menu,
    pager,
    Footer,
    CourseList
  }
};
</script>

<style lang="scss" scoped>
body{background: white;}
.page{background: white;}
.cContent {
  width: 1200px;
  margin: 20px auto;
  background: white;
  padding: 20px 0;
  .tab {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0;
    li {
      padding: 5px 15px;
      color: #8a8888;
      border-radius: 15px;
      margin-right: 15px;
      font-size: 1.4em;
      cursor: pointer;
    }
    .active {
      background: #3283fd;
      color: white;
    }
  }
  .list{min-height: 500px;}
}
</style>